<div *ngIf="report">

  <div [style]="styles.front_page.logo">
    <img *ngIf="logo" [src]="logo" style="height: 90px"/>
  </div>

  <div [style]="styles.front_page.image">
    <img *ngIf="front_image" [src]="front_image" style="max-width: 100%"/>
  </div>

  <div [style]="styles.front_page.container">
    <div [style]="styles.front_page.content">
      <div [style]="styles.front_page.template"><b>{{ report.templateType }}</b></div>
      <div [style]="styles.front_page.report">
        <b>REPORT</b>
      </div>
      <div [style]="styles.front_page.name">For {{ report.name }}</div>
    </div>
  </div>

</div>